module.exports = __webpack_public_path__ + "img/jessie.67228e12.jpg";